import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import { useAlerts } from '../../contexts/AlertContext'

const AppLayout: React.FC = () => {
  const { alerts, removeAlert } = useAlerts()

  return (
    <div className="min-h-screen bg-gray-50 overflow-x-hidden">
      {/* Alerts */}
      <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm sm:max-w-sm">
        {alerts.map((alert) => (
          <div
            key={alert.id}
            className={`w-full p-3 sm:p-4 rounded-md shadow-lg ${
              alert.type === 'success' 
                ? 'bg-green-100 text-green-800 border border-green-200'
                : alert.type === 'error'
                ? 'bg-red-100 text-red-800 border border-red-200'
                : alert.type === 'warning'
                ? 'bg-yellow-100 text-yellow-800 border border-yellow-200'
                : 'bg-blue-100 text-blue-800 border border-blue-200'
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="text-xs sm:text-sm font-medium pr-2">{alert.message}</span>
              <button
                onClick={() => removeAlert(alert.id)}
                className="ml-2 text-gray-400 hover:text-gray-600 flex-shrink-0"
              >
                <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Main content area - no sidebar margins needed */}
      <div className="w-full">
        {/* Header */}
        <div className="relative overflow-visible w-full">
          <Header />
        </div>

        {/* Page content */}
        <main className="p-3 sm:p-6 w-full min-w-0 overflow-x-hidden">
          <Outlet />
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  )
}

export default AppLayout
